import React from "react";
import FontAwesome from "react-fontawesome";

const RenderRegisterList = ({ list, lastBookElementRef, onClick }) => {
  return (
    <>
      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div key={index}>
                <div
                  ref={lastBookElementRef}
                  className="card shadow  m-1 "
                >
                  <div className="row m-1 d-flex align-items-center">
                    <div className=" col-xs-6 col-sm-4 col-md-3 lg-3 ">
                      <div style={{ fontSize: "22px" }}>
                        <span className="badge rounded-pill bg-primary">
                          {item.no}
                        </span>
                      </div>
                      <div
                        style={{ fontSize: "14px", cursor: "pointer" }}
                        onClick={() =>
                          onClick(
                            item.imageUrl,
                            item.firstdriven +
                              item.provincecode +
                              " " +
                              item.recordtime
                          )
                        }
                      >
                        {item.firstdriven} {item.provincecode} {"  "}{" "}
                        {item.platetype} {item.vehicletype}
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {"LPR No."} {item.deviceid} {"Color:  "} {item.color}
                      </div>
                    </div>
                    <div className=" col-xs-3 col-sm-2 col-md-3 lg-2 ">
                      <div style={{ fontSize: "15px" }}>
                        {item.confidencelevel > 0 ? (
                          <span
                            style={{ fontSize: "15px" }}
                            className="badge rounded-pill bg-success"
                          >
                            {"ความแม่นยำ "} {item.confidencelevel}
                          </span>
                        ) : null}
                      </div>
                    </div>

                    {item.chkedit ? (
                      <div className=" col-xs-3 col-sm-2 col-md-2 lg-1 ">
                        {item.chkedit ? (
                          <div style={{ fontSize: "15px" }}>
                            <span className="badge rounded-pill bg-secondary">
                              {"แก้ไข"}
                            </span>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                      <div className=" col-xs-6 col-sm-4 col-md-4 lg-4">
                    <button
                      className="btn btn-warning btn-sm m-1"
                      onClick={() =>
                        onClick(
                          item.imageUrl,
                          item.firstdriven +
                            item.provincecode +
                            " " +
                            item.recordtime
                        )
                      }
                    >
                      Click
                      <FontAwesome name="info-circle" />
                    </button>
                    
                    </div>
                    <div className=" col-xs-6 col-sm-4 col-md-3 lg-3">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          เวลา :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.recordtime}
                          </small>{" "}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div
                ref={lastBookElementRef}
              
                key={index}
              >
                <div className="card  shadow m-1">
                  <div className="row m-1 d-flex align-items-center">
                    <div className=" col-xs-6 col-sm-4 col-md-3 lg-3 ">
                      <div style={{ fontSize: "22px" }}>
                        <span className="badge rounded-pill bg-primary">
                          {item.no}
                        </span>
                      </div>
                      <div
                        style={{ fontSize: "14px", cursor: "pointer" }}
                        onClick={() =>
                          onClick(
                            item.imageUrl,
                            item.firstdriven +
                              item.provincecode +
                              " " +
                              item.recordtime
                          )
                        }
                      >
                        {item.firstdriven} {item.provincecode} {"  "}{" "}
                        {item.platetype} {item.vehicletype}
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {"LPR No."} {item.deviceid} {"Color:  "} {item.color}
                      </div>
                    </div>

                    {item.chkedit ? (
                      <div className=" col-xs-3 col-sm-2 col-md-2 lg-1  d-flex align-items-center">
                        {item.chkedit ? (
                          <div style={{ fontSize: "15px" }}>
                            <span className="badge rounded-pill bg-secondary">
                              {"แก้ไข"}
                            </span>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    <div className=" col-xs-3 col-sm-2 col-md-2 lg-2 ">
                      <div style={{ fontSize: "15px" }}>
                        {item.confidencelevel > 70 ? (
                          <span
                            style={{ fontSize: "15px" }}
                            className="badge rounded-pill bg-success"
                          >
                            {"ความแม่นยำ "} {item.confidencelevel}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className=" col-xs-6 col-sm-4 col-md-4 lg-4">
                    <button
                      className="btn btn-warning btn-sm"
                      onClick={() =>
                        onClick(
                          item.imageUrl,
                          item.firstdriven +
                            item.provincecode +
                            " " +
                            item.recordtime
                        )
                      }
                    >
                      {" "}
                      Click
                      <FontAwesome name="info-circle" />
                    </button>
                    </div>
                    {/* <div className=" col-xs-6 col-sm-4 col-md-4 lg-4">
                      <div className="mytooltip tooltip-effect-1">
                        <span className="tooltip-item">
                          <span className="d-none d-md-inline text-black pr-2">
                            <img
                         
                              src={item.imageUrl}
                              alt=""
                              style={{
                                maxHeight: 100,
                                Width: 300,
                              }}
                            />{" "}
                            {item.Driver_Name}{" "}
                          </span>
                        </span>

                      
                      </div>
                    </div> */}

                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-3">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          เวลา :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.recordtime}
                          </small>{" "}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default RenderRegisterList;
